<script lang="ts" setup>
import type { DialogOverlayProps } from 'reka-ui'
import { cn } from '@/utils/shadcn'
import { DrawerOverlay } from 'vaul-vue'
import { computed } from 'vue'
import type { HtmlHTMLAttributes } from 'vue'

const props = defineProps<
  DialogOverlayProps & { class?: HtmlHTMLAttributes['class'] }
>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <DrawerOverlay
    v-bind="delegatedProps"
    :class="
      cn(
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80',
        props.class,
      )
    "
    data-slot="drawer-overlay"
  />
</template>
